import { AxiosError } from 'axios'

import messages from '@/config/messages'

export const getErrorMessage = (error: unknown) => {
  const response = (error as AxiosError<unknown> | undefined)?.response

  return typeof response?.data === 'string'
    ? response.data
    : messages.errors.somethingWentWrong
}
